import React, { useState, useEffect } from 'react';
import { checkRU, getRuPageSlug, prepareImages } from '../../index';
import axios from 'axios';
import * as DOMPurify from 'dompurify';
import RouteUrl from '../RouteEnum';

import Footer from '../PageComponents/Footer';
import Header from '../PageComponents/Header';
import ErrorWrapper from "../PageComponents/ErrorWrapper";


import "./Page.css";


const GiftVoucherPage = () => {
    const { isRu, apiUrl } = checkRU();
    const [data, setData] = useState({});
    const [error, setError] = useState(false);
    const path = [{ link: "", title: isRu ? "Подарочный сертификат" : "Подарунковий сертифікат" }];

    useEffect(() => {
        window.scrollTo(0, 0);
        axios.get(getRuPageSlug(RouteUrl.giftVoucher)).then(res => {
            setData(res.data);
        }).catch(err => setError(true));
    }, []);

    return (
        <ErrorWrapper error={error}>
            <Header path={path} data={data} />
            <div className="frame last">
                <h1 className="main-header">{data.title1 && data.title1.toUpperCase().split('|').join('\n')}</h1>
                <div className="" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(prepareImages(data.text1)) }}></div>
                <div className="important-caveat" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(prepareImages(data.text2)) }}></div>
            </div>
            <Footer nested="1" />
        </ErrorWrapper>
    );
}

export default GiftVoucherPage;